export default "__VITE_ASSET__3e118e0f__"